import "../../new.scss";
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useContext, useEffect, useRef } from "react";
import { BarriosFormContext } from '../../../context/barrios/BarriosContext';
import LocalidadesModal from '../../localidades/localidadesModal/localidadesModal';
import DepartamentosModal from '../../departamentos/departamentosModal/departamentosModal';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const { report, postBarrioData, patchBarrioData } = useContext(BarriosFormContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchFilter, setSearchFilter] = useState();
  const [searchDescFilter, setSearchDescFilter] = useState('');

  const nameData = "barrios";
  const saveData = postBarrioData;
  const updateData = patchBarrioData;

  useEffect(() => {
    console.log("report", report)
    if (report && Object.keys(report).length > 0) {
      setForm((prevForm) => ({
        ...report,  // Copia todos los valores de report
        loc_id: report.loc_id || "",  // Asegura que ramo_Id esté seteado
      }));
      setSearchFilter(report?.loc_barrio?.id);
      setSearchDescFilter(report?.loc_barrio?.loc_descripcion || "");

    }
  }, [report]);


  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form);
  };

  const validateForm = () => {
    let formErrors = {};


    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);


  // Enviar datos
  const handleSendData = () => {
    if (!validateForm()) {
      // Usamos un callback para asegurarnos de que `errors` esté actualizado
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs.reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name; // Usar el label si existe, si no, usar el nombre del campo
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);

        // Solo abrimos el diálogo de error cuando se hayan generado los mensajes
        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray);
        }

        return prevErrors; // No modificamos el estado aquí
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    const formUpdated = {
      ...form,
      loc_id: searchFilter
    };

    try {
      if (id) {
        await updateData(id, formUpdated);
      } else {
        await saveData(formUpdated);
      }
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {Inputs.map((input, index) => {
                const key = input.id ?? `${input.name}-${index}`;
                if (input.name === "loc_id") {
                  return (
                    <div className="formInput" key={input.id || key} >
                      <label>{input.label}</label>
                      <LocalidadesModal
                        handleChange={setSearchFilter}
                        handleDescChange={setSearchDescFilter}
                        descSelected={searchDescFilter}
                      />
                      {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                    </div>
                  );
                } else {
                  return (
                    <FormField
                      key={input.id}
                      input={input}
                      value={form[input.name] || ""}
                      handleInputChange={(e) => handleChange(e)}
                      error={errors[input.name]}
                    />
                  );
                }
              })} </form>
            <FormButtons
              isSubmitting={isSubmitting}
              handleSave={handleSendData}
              handleCancel={handleCancel}
              saveText="Guardar"
              cancelText="Cancelar"
            />


            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
